import React from 'react'

interface ProgressProps {
  progress: number
  height?: string
  width?: string
}

const Progress: React.FC<ProgressProps> = ({
  progress,
  height = 'h-5',
  width = 'w-full',
}) => {
  const progressValue = Math.min(Math.max(progress, 0), 100)

  return (
    <div
      className={`bg-tertiary-5 rounded-full overflow-hidden ${height} ${width}`}
    >
      <div
        className={`${progress === 100 ? 'bg-success-1' : 'bg-primary-1'} h-full transition-all ease-in-out`}
        style={{ width: `${progressValue}%` }}
      />
    </div>
  )
}

export default Progress
